module.exports = __webpack_public_path__ + "0c64ab3c5c731549daecacacdded5f39.png";